import styled from 'styled-components';
import {
  StyledDropdown as _StyledDropdown,
  StyledDropdownContent as _StyledDropdownContent,
  StyledHeaderIcon as _StyledHeaderIcon,
} from 'components/HeaderDropdownMenu/styled';

export const StyledDropdown = styled(_StyledDropdown)`
  &&& {
    .dropdown__trigger {
      padding: 0 4px;
    }
  }
`;

export const StyledDropdownContent = styled(_StyledDropdownContent)`
  &&& {
    right: -12px;
  }
`;

export const StyledHeaderIcon = styled(_StyledHeaderIcon)`
  font-size: 16px;
  line-height: 16px;
`;
